// extracted by mini-css-extract-plugin
export default {"tooltip":"EO-z","arrow":"FO-z"};